import styled from 'styled-components';
import { rem, theme } from '@/styles/theme';
import { PLACEHOLDER_AVATAR_CIRCLE } from '@/const';

interface IAvatarCircleProps {
  size: string;
}

const Wrapper = styled.div<IAvatarCircleProps>`
  display: flex;
  flex-shrink: 0;
  box-sizing: border-box;
  border: 1px solid ${theme.color['gray-100']};
  border-radius: 50%;
  position: relative;
  aspect-ratio: 1/1;
  overflow: hidden;
  ${({ size }) =>
    size === 'md'
      ? `
    width: ${rem(44)};
    height: ${rem(44)};
  `
      : `
    width: ${rem(56)};
    height: ${rem(56)};
  `}
  ${({ theme, size }) =>
    size === 'md' &&
    theme.media.fold`
      width: ${rem(36)};
      height: ${rem(36)};
  `}
  ${({ theme, size }) =>
    size === 'lg' &&
    theme.media.fold`
      width: ${rem(44)};
      height: ${rem(44)};
    `}
`;

const Image = styled.img`
  width: 100%;
  object-fit: cover;
`;

interface IProps {
  src: string | undefined;
  size?: string;
  alt?: string;
}

const AvatarCircle = (props: IProps) => {
  const { src = '', size = 'md', alt = '' } = props;

  return (
    <Wrapper size={size}>
      <Image src={src || PLACEHOLDER_AVATAR_CIRCLE} alt={alt} loading="lazy" />
    </Wrapper>
  );
};

export default AvatarCircle;
